// Base stylesheet needed for every page
import './scss/app.scss';

require('./scripts/bundles');
require('./scripts/cart');
require('./scripts/cookiebar');
require('./scripts/customer');
require('./scripts/filters');
require('./scripts/footer');
require('./scripts/navigation');
require('./scripts/product');
require('./scripts/popup');
require('./scripts/productBlock');
require('./scripts/productGallery');
require('./scripts/productPopup');
require('./scripts/quantity');
require('./scripts/slider');
require('./scripts/search');
require('./scripts/staffel');
require('./scripts/recently-viewed');
require('./scripts/wishlist');